// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 10H22V22H16V16H8V22H2V10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10 22V18H14V22H10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 2H9V4H10V8H20V4H21V2ZM15.0039 4.99805V7.00195H13V4.99805H15.0039Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-building-4-filled')
export default class Building4FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'building-4-filled',
    }
  }
}
